import React, { useState, useEffect } from "react";
import axios from "axios";
import axiosInstance from "../../apiInstances/axiosInstance";
import { BACKEND_BASE_URL } from "../../apiInstances/baseurl";

const FileUpload = ({ onFileUpload }) => {
  const [file, setFile] = useState(null);

  useEffect(() => {
    submit();
  }, []);

  const submit = async () => {
    axiosInstance
      .post(`get_allform`, {
        name: "F-005 Management Review.docx",
      })
      .then((response) => {
        const data = response.data;
        const fileUrl = `${BACKEND_BASE_URL}${data.data}`;

        // Create a Blob from the file URL
        fetch(fileUrl)
          .then((res) => res.blob())
          .then((blob) => {
            const file = new File([blob], data.fileName, { type: blob.type });
            setFile(file);

            // Call the onFileUpload function with the uploaded file
            onFileUpload(file);
          })
          .catch((error) => {
            console.error("Error fetching the file:", error);
          });
      })
      .catch((error) => {
        console.error("Error fetching API response:", error);
      });
  };
  return (
    <div>
      {file && (
        <div>
          <p>Uploaded File: {file.name}</p>
          {/* <a
                    href={URL.createObjectURL(file)}
                    download={file.name}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Download File
                </a> */}
        </div>
      )}
    </div>
  );
};

export default FileUpload;
